<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Layout'
}
</script>

<style lang="less">
  @import '../../index';
  @font-face {
    font-family: 'qfb-icon';
    src: url('//at.alicdn.com/t/font_468904_6upemxx6y7p.ttf') format('truetype');
  }
  .panel {
    width: 96%;
    margin: .2rem auto;
  }
  .panel-title {
    height: .9rem;
    line-height: .9rem;
    font-size: 0.4rem;
    background-color: @panel-color;
    text-align: center;
    color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .panel-content {
    border: 1px solid @panel-color;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 3%;
    background-color: #fff;
  }
  .panel-content > p {
    font-size: 0.3rem;
    line-height: 0.47rem;
    color: #454545;
    text-indent: 2em;
    text-align: justify;
  }
  .marquee-merit {
    height: 5rem;
    width: 100%;
    overflow: hidden;
  }
  .merit-list div{
    line-height: .5rem;
    font-size: .28rem;
    overflow: hidden;
  }
  .merit-list div span {float:left;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
  #merit-form .van-cell {
    font-size: .3rem;
    height: 1rem;
  }
  #merit-form .form-label {
    font-weight: bold;
    width: 2rem;
    flex: none;
    color: @cell-color;
  }
  #merit-form input{
    color: @cell-color;
  }
  #merit-form .radio {
    color: #b2947c;
  }
  #merit-form input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{font-size:.3rem;font-family:sans-serif; color: #b2947c;}
  #merit-form .submit-btn {
    background-color: @btn-color;
    color: #fff;
    font-size: 0.4rem;
  }
  .form-desc .title {
    height: .5rem;
    overflow: hidden;
    text-align: left;
    font-size: .3rem;
    font-weight: 600;
    color: @btn-color;
  }
  .form-desc .desc {
    height: .35rem;
    font-size: .25rem;
    overflow: hidden;
    text-align: left;
    color: #666666;
  }

  #audio_btn {
    position: fixed;
    z-index: 999;
    top: 55px;
    right: 10px;
    width: 30px;
    height: 30px;
    background-image: url(http://img.qifudeng.com/prj/site/bgmicon.png);
    background-size: contain;
  }

  .rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite
  }

  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(0)
    }

    to {
      -webkit-transform: rotate(360deg)
    }
  }

  @keyframes rotating {
    from {
      transform: rotate(0)
    }

    to {
      transform: rotate(360deg)
    }
  }

  @-moz-keyframes rotating {
    from {
      -moz-transform: rotate(0)
    }

    to {
      -moz-transform: rotate(360deg)
    }
  }
</style>
